export default __webpack_public_path__ + "static/media/art-sub.5799562e.png";